import React from "react";
import { LoadingPageStyle as S } from "./LoadingPage.style";
import { PProgressSpinner } from "@prime/PProgressSpinner/PProgressSpinner";

export const LoadingPage: React.FC<{}> = () => {
  return (
    <S.LoadingPage>
      <PProgressSpinner />
    </S.LoadingPage>
  );
};
